import { useContext, useEffect, useRef, useState } from "react";
import { Appcontext, Dispatchcontext } from "./Reducercontext";

function Card(props) {
  let options = props.options1;
  let priceoptions = Object.keys(options);
  const usecart = useContext(Appcontext);
  const dispatch = useContext(Dispatchcontext);
  const [qty, setqty] = useState(1);
  const [size, setsize] = useState("");
  const priceref = useRef();

  // State to trigger animation class
  const [isAnimating, setIsAnimating] = useState(false);

  const addtocart = async () => {
    // Trigger animation
    setIsAnimating(true);

    // Remove animation class after animation duration (400ms)
    setTimeout(() => setIsAnimating(false), 400);

    await dispatch({
      type: "add",
      id: props.fooditem._id,
      name: props.fooditem.name,
      img: props.fooditem.img,
      description: props.fooditem.description,
      price: finalprice,
      qty: qty,
      size: size,
    });

    console.log(usecart);
  };

  let finalprice = qty * options[size];

  useEffect(() => {
    setsize(priceref.current.value);
  }, []);

  return (
    <div className="parentcard">
      <div className="card">
        <img className="card-img-top" src={props.fooditem.img} alt="" />
        <div className="card-body">
          <h5 className="card-title">{props.fooditem.name}</h5>
          <p className="card-text">{props.fooditem.description}</p>
          <div className="opt">
            <select
              className="slt1"
              onChange={(e) => {
                setqty(parseInt(e.target.value));
              }}
              value={qty}
            >
              {[...Array(9)].map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>

            <select
              className="slt2"
              ref={priceref}
              onChange={(e) => setsize(e.target.value)}
              value={size}
            >
              {priceoptions.map((data) => (
                <option key={data} value={data}>
                  {data}
                </option>
              ))}
            </select>

            <p>₹/{finalprice}</p>
          </div>

          <div className="divcart">
            <button
              onClick={addtocart}
              className={`addtocart ${isAnimating ? "animate-cart" : ""}`}
            >
              ADD TO CART
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
